<template>
  <div class="soldout-page inner">
    <site-menu theme="dark" class="menu"/>
    <h1>Item Sold Out</h1>
    <divider />
    <illustration />
  </div>
</template>
<script>
  import SiteMenu from '@/components/SiteMenu.vue'
  import Illustration from '@/components/Illustration.vue'
  export default {
    name: 'soldout-page',
    components: { SiteMenu, Illustration },
  }
</script>
<style lang="scss" scoped>
  h1 {
    text-align: center;
    color: $color-2;
    font-weight: 200;
    margin: 0;
    text-transform: uppercase;
    font-size: 100px;
    margin: 100px auto;
  }

</style>
